import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4744_64734)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.57508 7.50008C7.771 6.94314 8.15771 6.4735 8.66671 6.17436C9.17571 5.87521 9.77416 5.76586 10.3561 5.86568C10.938 5.96549 11.4658 6.26802 11.846 6.71969C12.2262 7.17136 12.4343 7.74302 12.4334 8.33342C12.4334 10.0001 9.93342 10.8334 9.93342 10.8334M10.0001 14.1667H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z",
			stroke: "#858DAD",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4744_64734",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgHelpCircle;
